import { StatusCodes } from "http-status-codes";
import { request } from "../../api";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
import { headers } from "../../../../config/config";

const { post, get, patch, put } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "reports";

export const emptyBenefitAmountReport = async (_payload: any) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/VEB/empty-benefit-amount`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
